import useApp from '@/composables/useApp'
import mqtt from 'mqtt'
import { useStore } from 'vuex'
import emitter from "@/eventBus"
import axios from '@/axios'
const startMqttClient = async () => {
  const { ToastMsgInfo, updateTemplate } = useApp()
  const store = useStore()
  let client = null


  let data = {
    timeRequestCredentials: 0,
    countRequestCredentials: 0,
    options: {
      keepalive: 55,
      host: String(process.env.VUE_APP_MQTT_HOST),
      port: String(process.env.VUE_APP_MQTT_PORT),
      endpoint: "/mqtt",
      clean: true,
      connectTimeout: 5000,
      reconnectPeriod: 5000,

      // Certification Information
      clientId:
        "web_" +
        store.state.auth.userData.email.split("@")[0].replace("ñ", "n") +
        "_" +
        Math.floor(Math.random() * 1000000 + 1),
      username: "",
      password: ""
    }
  }
  const getMqttCredentials = async () => {
    try {
      const axiosHeaders = {
        headers: {
          token: store.state.auth.token
        }
      };

      const credentials = await axios.post(
        "/getmqttcredentials",
        null,
        axiosHeaders
      );

      if (credentials.data.status == "success") {
        data.options.username = credentials.data.username;
        data.options.password = credentials.data.password;
      }
    } catch (error) {
      // console.log(error);

      if (error.response == null) {
        console.log("Error Server Api");
        return
      }

      if (error.response.status == 401) {
        console.log("NO VALID TOKEN");
        localStorage.clear();

        const auth = {};
        store.commit("setAuth", auth);
        window.location.href = "/login";
      }
    }
  }

  const getMqttCredentialsForReconnection = async () => {
    try {
      const axiosHeaders = {
        headers: {
          token: store.state.auth.token
        }
      };

      const credentials = await axios.post(
        "/getmqttcredentialsforreconnection",
        null,
        axiosHeaders
      );
      //console.log(credentials.data);

      if (credentials.data.status == "success") {
        client.options.username = credentials.data.username;
        client.options.password = credentials.data.password;
      }
    } catch (error) {

      // console.log(error);

      if (error.response == null) {
        console.log("Error API Server")
        return
      }

      if (error.response.status == 401) {
        console.log("NO VALID TOKEN");
        localStorage.clear();

        const auth = {};
        store.commit("setAuth", auth);
        window.location.href = "/login";
      }

    }
  }
  const initMqttClient = async () => {
    await getMqttCredentials();
    //ex topic: "userid/did/variableId/sdata"
    let userId = store.state.auth.userData._id
    if (store.state.auth.userData.role == "monitor"){
      userId = store.state.auth.userData.linkedClient
    }
    const deviceSubscribeTopic =
    userId + "/+/+/sdata";
    const notifSubscribeTopic =
    userId + "/+/+/notif";
    const deviceSubscribeInfo =
    userId + "/+/info";

    const connectUrl =
      String(process.env.VUE_APP_MQTT_PREFIX) +
      data.options.host +
      ":" +
      data.options.port +
      data.options.endpoint;

    try {
      // console.log(connectUrl)
      client = mqtt.connect(connectUrl, data.options);
    } catch (error) {
      console.log(error);
    }

    //MQTT CONNECTION SUCCESS
    client.on("connect", () => {

      console.log("Connection succeeded!");
      data.countRequestCredentials = 0;
      emitter.emit("connected-mqtt", { connected: true })
      store.commit("setMqttStatus", true)
      //SDATA SUBSCRIBE
      client.subscribe(deviceSubscribeTopic, { qos: 0 }, err => {
        if (err) {
          console.log("Error in DeviceSubscription");
          return;
        }
        console.log("Device subscription Success");
        //console.log(deviceSubscribeTopic);
      });

      //NOTIF SUBSCRIBE
      client.subscribe(notifSubscribeTopic, { qos: 0 }, err => {
        if (err) {
          console.log("Error in NotifSubscription");
          return;
        }
        console.log("Notif subscription Success");
        //console.log(notifSubscribeTopic);
      });

      client.subscribe(deviceSubscribeInfo, { qos: 0 }, err => {
        if (err) {
          console.log("Error in deviceSubscribeInfo");
          return;
        }
        console.log("deviceSubscribeInfo Success");
        //console.log(notifSubscribeTopic);
      });

    });

    client.on("error", error => {
      console.log("Connection failed", error);
      store.commit("setMqttStatus", false)
    });

    client.on("reconnect", error => {
      store.commit("setMqttStatus", false)
      if (document.visibilityState == 'visible') {

        if (data.countRequestCredentials > 6) {
          if (confirm("Houston! Estamos Sin Conexion Desea Refrescar la Pagina ?")) {
            //router.go(router.currentRoute.path);
          } else {
            data.countRequestCredentials;
          }

        }

        if (Date.now() - data.timeRequestCredentials > 5000) {
          getMqttCredentialsForReconnection();
          data.countRequestCredentials++;
          data.timeRequestCredentials = Date.now();
        }

      }

      console.log("reconnecting:", error);

    });

    client.on("disconnect", error => {
      store.commit("setMqttStatus", false)
      console.log("MQTT disconnect EVENT FIRED:", error);
    });

    client.on("message", (topic, message) => {
      // console.log("Message from topic " + topic + " -> ");
      // console.log(message.toString());
      try {
        const splittedTopic = topic.split("/");
        const msgType = splittedTopic[3];
        const dId = splittedTopic[1]
        const variable = splittedTopic[2]
        
        if (msgType == "notif") {
          ToastMsgInfo(message.toString(), "clock", 6000)
          store.dispatch("getNotifications");
          return;
        

        } else if (msgType == "sdata") {
          const data = JSON.parse(message)
          if (variable == "sensors"){
            Object.keys(data).forEach( key => {
              if (key != "svdt"){
                const adapTopic = `${splittedTopic[0]}/${splittedTopic[1]}/${key}/sdata`
                setTimeout(()=>{
                  emitter.emit(adapTopic, {value: data[key]})
                },200)
              }
            });
          }

          if (dId == store.state.selectedDevice.dId) {
            store.commit("setDeviceActive", true)
          }

          if (variable == "info"){
            // console.log(data)
            if (dId == store.state.selectedDevice.dId) {
              store.commit("setDeviceActive", true)
              store.commit("setDeviceInfo", data)
            }
          }

          if (variable == "status"){
            if (dId == store.state.selectedDevice.dId) {
              if (data.connected){
                store.commit("setDeviceActive", true)
              }else if (data.timestamp){
                store.commit("setDeviceLastTime", data.timestamp)
                store.commit("setDeviceActive", false)
              }
            }
          }
          if (variable == "templates"){
            if (dId == store.state.selectedDevice.dId){
              console.log(data)
              updateTemplate(data);
            }
          }
          if (variable == "params"){
            if (dId == store.state.selectedDevice.dId){
              store.commit("setDeviceParams", data)
            }
          }
          return 
        } 
      } catch (error) {
        console.log(error);
      }
    });

    emitter.on("mqtt-sender", toSend => {
      client.publish(toSend.topic, JSON.stringify(toSend.msg))
    })
  }

  setTimeout(() => {
    initMqttClient()
  }, 1000)
}


export { startMqttClient }
